/*
 * axios封装
 */
import axios from 'axios'
import { message } from 'ant-design-vue'
import store from '../store/main'
import router from '../router/main'
import qs from 'qs'

// 请求超时时间
axios.defaults.timeout = 30000

axios.interceptors.request.use(
  (config) => {
    let token = store.state.token && store.state.token != ''
    if (token) {
      config.headers.common['X-Auth-Token'] = store.state.token
    }

    if (config.method === 'get') {
      //如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    // 请求是2xx的时候
    const token = response.headers['x-subject-token']
    if (token) {
      store.state.token = token
    }
    return Promise.resolve(response.data)
  },
  // 服务器状态码不是200的情况
  (error) => {
    console.log("error",error)
    if (error.response == undefined) {
      message.error('请求超时')
    } else if (error.response.status === 400 || error.response.status === 403 || error.response.status === 404) {
      let data = error.response.data
      message.error(data.message)
      return Promise.reject(error)
    }  else if (error.response.status === 401) {
      let data = error.response.data
      message.error(data.message)
      // 判断当前路由，如果不是登录页面，则返回到登录页面
      const path = router.app.$route.path
      if (path !== '/login') {
        router.push('/login')
      }
      store.state.token = ''
      store.state.userInfo = null
      return Promise.reject(error)
    } else if (Math.floor(error.response.status / 100) == 5) {
      message.error('系统异常')
    }
    return Promise.reject(error)
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function GET(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then((data) => {
        if (data.code == 200) {
          if (data.dto) {
            resolve(data.dto)
          } else {
            resolve(data)
          }
        } else {
          reject(data.msg)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function POST(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((data) => {
        if (data.code == 200) {
          if (data.dto) {
            resolve(data.dto)
          } else {
            resolve(data)
          }
        } else {
          resolve(data)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function DELETE(url) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url)
      .then((data) => {
        resolve(data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function PUT(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((data) => {
        resolve(data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * patch方法，对应patch请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function PATCH(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .patch(url, params)
      .then((data) => {
        resolve(data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * 导出文件
 * @param {url}} url
 * @param {参数} params
 * @param {文件名} filename
 * @returns
 */
export function EXPORT(url, params, filename) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      params: params
    })
      .then((data) => {
        let link = document.createElement('a')
        link.href = URL.createObjectURL(data)
        link.setAttribute('download', filename)
        link.click()
        link = null
        resolve(data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export function PREVIEW(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      params: params
    })
      .then((data) => {
        let pdfUrl = window.URL.createObjectURL(data)
        window.open(pdfUrl)
        resolve(data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
